<template>
  <validationObserver
    ref="aiForm"
    v-slot="{ handleSubmit }"
    slim
  >
    <b-card
      title="Update AI Settings"
    >
      <b-overlay
        :show="loading"
        blur="10px"
        opacity="0.30"
        rounded="sm"
        variant="light"
      >
        <b-form
          ref="aiForm"
          @submit.prevent="handleSubmit(updateAiSetting)"
        >
          <!-- Start of : Tax   -->
          <b-row>
            <b-card
              title="Enable DSR"
            >
              <b-form-radio-group
                v-model="ai_setting.enabled"
                :options="dsrOptions"
                value-field="item"
                text-field="name"
                disabled-field="notEnabled"
                :disabled="!canEditAiSetting"
                @change="updateAiSetting()"
              />
            </b-card>
          </b-row>
          <b-row>
            <div class="ml-2">
              If this Option is enabled all the AI features will be enabled to the merchants.
            </div>
          </b-row>
          <b-row
            v-if="ai_setting.enabled"
          >
            <b-card
              title="DSR Availability Preferences"
            >
              <b-form-radio-group
                v-model="ai_setting.availability_setting.preference"
                :options="availabilityOptions"
                value-field="item"
                text-field="name"
                disabled-field="notEnabled"
                :disabled="!canEditAiSetting"
                @change="updateAiSetting()"
              />
            </b-card>
          </b-row>
          <b-row>
            <b-card title="Claude AI Reporting">
              <b-form-radio-group
                v-model="claudeReporting.enabled"
                :options="dsrOptions"
                value-field="item"
                text-field="name"
                :disabled="!canEditAiSetting || claudeLoading"
                @change="saveClaudeReporting"
              />
              <p class="text-muted small mt-1 mb-0">
                When On, staff with the "Use Claude reporting" permission can connect Claude to their reports.
                It is Off by default.
              </p>
            </b-card>
          </b-row>
        </b-form>
      </b-overlay>
    </b-card>
  </validationObserver>
</template>

<script>
import { ValidationObserver, extend } from 'vee-validate'
import { max, numeric } from 'vee-validate/dist/rules'
import {
  BRow, BForm, BCard, BOverlay, BFormRadioGroup,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import { RepositoryFactory } from '@/repository/RepositoryFactory'

extend('max', max)
extend('numeric', numeric)

const AiSettingRepository = RepositoryFactory.get('aiSetting')

export default {
  components: {
    BRow,
    BForm,
    BCard,
    BOverlay,
    BFormRadioGroup,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  mixins: [SuccessMessage, ErrorMessage],
  data() {
    return {
      loading: false,
      ai_setting: {
        enabled: '',
      },
      claudeLoading: false,
      claudeReporting: { enabled: false },
      dsrOptions: [
        { item: true, name: 'On' },
        { item: false, name: 'Off' },
      ],
      availabilityOptions: [
        { item: 'all', name: 'All Merchants' },
        { item: 'selective', name: 'Selective' },
      ],
    }
  },
  computed: {
    canEditAiSetting() {
      return this.$can('edit-ai-setting')
    },
  },
  mounted() {
    this.readAiSetting()
    this.readClaudeReporting()
  },
  methods: {
    async readClaudeReporting() {
      this.claudeLoading = true
      try {
        const res = await AiSettingRepository.getClaudeReporting()
        this.claudeReporting = { enabled: !!res.data.data.enabled }
      } catch (e) {
        this.showErrorMessage('Could not load Claude reporting setting')
      } finally {
        this.claudeLoading = false
      }
    },
    async saveClaudeReporting() {
      this.claudeLoading = true
      try {
        await AiSettingRepository.updateClaudeReporting({ enabled: this.claudeReporting.enabled })
        this.showSuccessMessage(`Claude AI Reporting ${this.claudeReporting.enabled ? 'turned on' : 'turned off'}`)
      } catch (e) {
        this.showErrorMessage('Could not save Claude reporting setting')
        this.readClaudeReporting()
      } finally {
        this.claudeLoading = false
      }
    },
    async readAiSetting() {
      this.loading = true
      try {
        const data = localStorage.getItem('ai_setting') ? JSON.parse(localStorage.getItem('ai_setting')) : (await AiSettingRepository.getAiSetting()).data.data
        if (!localStorage.getItem('ai_setting')) localStorage.setItem('ai_setting', JSON.stringify(data))
        this.ai_setting = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.loading = false
    },
    async updateAiSetting() {
      const res = await AiSettingRepository.updateAiSetting(this.ai_setting)
      if (res.status === 200) {
        localStorage.setItem('ai_setting', JSON.stringify(this.ai_setting))
        this.showSuccessMessage('AI Settings Updated Successfully')
      } else {
        this.showErrorMessage('Cannot Update AI Settings')
      }
    },
  },
}
</script>
<style scoped lang="scss">
.set_right {
  float:right;
}
.custom-button-color {
  background-color: #4186f5 !important;
  border-color: #4186f5 !important;
}
</style>
